import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'UPAZILA_UPDATE',
    smsDelete : 'UPAZILA_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        upazila: [],

        submitSuccess: false,
        upazilaLoading: false,
        upazilaError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_UPAZILA(state, upazila) {
            state.upazila = upazila;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        UPAZILA_LOADING (state, loading) {
            state.upazilaLoading = loading;
        },

        UPAZILA_ERROR (state, hasError) {
            state.upazilaError = hasError;
        }
    },

    actions: {
        async addUpazila ({commit, dispatch}, payload) {
            commit('UPAZILA_LOADING', true);
            commit('UPAZILA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_upazila, payload.upazila, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchUpazila')
                return response

            } catch (e) {
                commit('UPAZILA_ERROR', true);
            } finally {
                commit('UPAZILA_LOADING', false);
            }
        },

        async fetchUpazila ({ commit }) {
            commit('UPAZILA_LOADING', true);
            commit('UPAZILA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.upazila_list, config);
                let response = result.data
                commit('SET_UPAZILA', response.data);

            } catch(error) {
                commit('UPAZILA_ERROR', true);
            } finally {
                commit('UPAZILA_LOADING', false);
            }
        },

        async updateUpazila ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_upazila + payload.id, payload.upazila, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchUpazila')
                return response

            } catch (e) {
                commit('UPAZILA_ERROR', true);
            } finally {
                commit('UPAZILA_LOADING', false);
            }
        },
        
        async deleteUpazila({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.upazila_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchUpazila')
            return response
        }
    },

    getters: {}
}
